import { Td, Text, Tr } from "@chakra-ui/react";
import { ResidenceTypeModel } from "../../clients/BackOfficeApi";
import { ResidenceTypeImage } from "../../elements/ResidenceTypeImage";
import { WarningIcon } from "@chakra-ui/icons";
import { ResidenceTypeActions } from "./ResidenceTypeActions";
import { LinkButton } from "../../elements/LinkButton";
import { VisibilityIcon } from "../../elements/VisibilityIcon";

interface Props {
  residenceType: ResidenceTypeModel;
  onChange?: () => void;
}

export function ResidenceTypeListRow({
  residenceType,
  onChange = () => {},
}: Props) {
  return (
    <Tr key={residenceType.id}>
      <Td>
        {residenceType.hasImage ? (
          <ResidenceTypeImage id={residenceType.id} />
        ) : (
          <Text>
            <WarningIcon /> Nog geen afbeelding
          </Text>
        )}
      </Td>
      <Td>
        <LinkButton to={residenceType.id.toString()}>
          {residenceType.name}
        </LinkButton>
      </Td>
      <Td>
        <VisibilityIcon visibility={residenceType.visibility} />
      </Td>
      <Td>
        <ResidenceTypeActions
          forCell
          onChange={onChange}
          residenceType={residenceType}
        />
      </Td>
    </Tr>
  );
}
